<template>
  <div>
    <draggable
      v-bind="dragOptions"
      tag="div"
      class="widget-item-container mb-2"
      :list="list"
      :value="value"
      @input="inputEmit"
      @start="startEmit"
      @end="endEmit"
      swapThreshold="1"
    >
      <v-expansion-panels class="widget-item-group item-group" :key="el.id" v-for="el in realValue">
        <v-expansion-panel class="widget-item">
          <v-expansion-panel-header class="py-0">
            <template>
              <v-row no-gutters>
                <v-col cols="6">
                  <div class="d-flex align-center">
                    <v-icon class="widget-drag-icon">mdi-drag-horizontal </v-icon>
                    <v-icon v-if="el.elements.length > 0" class="widget-minus-icon">mdi-minus </v-icon>
                    <div class="d-flex align-center widget-input-sysname">
                      <div>
                        <input type="text" v-model="el.name" placeholder="Sys_Name" class="widget-input-sysname-input py-1 px-1" />
                      </div>
                      <div class="text-caption grey--text">
                        ( {{el.widget}} )
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex justify-end text--secondary">
                  <v-icon size="1rem" color="blue" v-if="el.permission.length">mdi-shield-account</v-icon>
                  <v-fade-transition leave-absolute></v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div v-if="isModuleWidget(el.widget)">
              <list-inputs :inputs="el.fields" />
            </div>
            <div v-else>
              <div class="pb-5" :key="key" v-for="(field, key) in el.fields">
                <v-text-field v-if="field.type === 'text'" prepend-icon="mdi-form-textbox" hide-details :placeholder="field.name" v-model="field.value"></v-text-field>

                <v-select
                  v-else-if="field.type === 'select'"
                  class="font-weight-light"
                  prepend-icon="mdi-select-search"
                  :items="autoSelects[field.data]"
                  label="Select Verisi"
                  v-model="field.value"
                  hint="Çekilecek select verisini seçin"
                  persistent-hint
                ></v-select>
              </div>
            </div>
            <v-divider class="mb-2"></v-divider>
            <div id="userRoles">
              <SelectRoles v-on:selectedRoles="el.permission = $event" v-model="el.permission" />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <div class="widget-item-sub">
          <draggable-widget v-bind="dragOptions" class="item-sub mt-2" :list="el.elements" />
          <!--          <div class="draggable-widget&#45;&#45;action">-->
          <!--            <div class="draggable-widget&#45;&#45;action-line"></div>-->
          <!--            <div class="draggable-widget&#45;&#45;action-btn">-->
          <!--              <v-tooltip bottom>-->
          <!--                <template v-slot:activator="{ on, attrs }">-->
          <!--                  <v-btn x-small icon class="primary white&#45;&#45;text" v-on="on" v-bind="attrs" @click="cloneById(el.id)">-->
          <!--                    <v-icon size=".85rem">mdi-plus</v-icon>-->
          <!--                  </v-btn>-->
          <!--                </template>-->
          <!--                <span>Ekleme yap</span>-->
          <!--              </v-tooltip>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </v-expansion-panels>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Routes from "@/router/views";
import { mapState } from "vuex";
import SelectRoles from "@/components/SelectRoles.vue";
import ListInputs from "../SystemSettings/ListInputs.vue";

export default {
  name: "DraggableWidget",

  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    },
    groupId: String
  },

  components: {
    ListInputs,
    draggable,
    SelectRoles
  },

  computed: {
    ...mapState({
      autoSelects: state => state.Widget.Widgets.autoSelects
    }),
    dragOptions() {
      return {
        animation: 0,
        group: "widget",
        disabled: false,
        ghostClass: "ghost",
        put: () => true,
        pull: false
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    }
  },

  methods: {
    inputEmit(value) {
      this.$emit("input", value);
    },
    startEmit(value) {
      this.$emit("start", value);
    },
    endEmit(value) {
      this.$emit("end", value);
    },
    isApiWidget(widgetSysName) {
      const sysNameArr = widgetSysName.split("/");

      return sysNameArr[0] === "Api";
    },
    isModuleWidget(widgetSysName) {
      const sysNameArr = widgetSysName.split("/");

      return sysNameArr[0] === "Module";
    },
    cloneById(id) {
      this.$emit("cloneById", id);
    }
  },

  created() {
    /**
     * Auto Selectleri Set Et
     */
    const autoSelects = {
      systemViews: Routes
    };

    this.$store.dispatch("Widget/Widgets/getAutoSelects", autoSelects);
  }
};
</script>

<style scoped lang="scss">
.item-container {
  max-width: 20rem;
  margin: 0;
}

.item {
  padding: 1rem;
  border: solid black 1px;
  background-color: #fefefe;
}

.item-sub {
  margin: 0 0 0 1rem;
}

.widget-container-empty .widget-item-container {
  min-height: 48px;
}

.ghost .widget-item {
  background: rgba(0, 136, 249, 0.09);
  border: 1px dashed #0088f8;
  color: transparent;
}

.ghost .widget-item > * {
  opacity: 0;
}

.widget-item-sub {
  width: 100%;
}

.widget-drag-icon {
  width: 10px;
  left: -10px;
  cursor: grab;
}

.widget-minus-icon {
  width: 15px;
  height: 10px;
  display: none;
}

.draggable-widget--action {
  width: 100%;
  //padding: 5px 0 5px 25px;
  position: relative;
  cursor: pointer;
}

.draggable-widget--action .draggable-widget--action-line {
  width: 100%;
  height: 3px;
  border-radius: 5px;
  background: #adadad;
  background: linear-gradient(to right, #c0c0c0, #adadad);
}

.draggable-widget--action .draggable-widget--action-btn {
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
}

//.draggable-widget--action:after {
//  content: "";
//  position: absolute;
//  width: 0;
//  height: 0;
//  border-style: solid;
//  border-width: 8px 17.6px 8px 0;
//  border-color: transparent #777777 transparent transparent;
//  right: -19px;
//  top: 50%;
//  transform: translateY(50%);
//  transform: translateY(calc(-50% - 1px));
//}

/* .widget-input-sysname {
  position: relative;
}

.widget-input-sysname span {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  background-color: red;
} */
</style>
